import '../sass/project.scss';

import 'htmx.org';

window.htmx = require('htmx.org');
